module.exports = __webpack_public_path__ + "assets/check-blue.e9508c4e.svg";